module.exports = __webpack_public_path__ + "static/media/tugwecare.a4984644.jpg";